import styled from "styled-components";

export const SubTitle = styled.p`
    line-height: 20px;
    font-size: 16px;
    text-transform: uppercase;
    font-weight: bold;
    letter-spacing: 5px;
    padding: 40px 0;
    position: relative;
    text-align: center;
    &::after{
        position: absolute;
        content: "";
        width: 30px;
        height: 3px;
        background-color: #ff7f00;
        bottom: 17px;
        right: 50%;
        transform: translateX(50%);
    }
    &::before{
        position: absolute;
        content: "";
        width: 30px;
        height: 3px;
        background-color: #ff7f00;
        top: 17px;
        right: 50%;
        transform: translateX(50%);
    }
    transition: 0.2s;
    @media screen and (max-width: 767px){
        padding: 40px 20px;
    }
`